// Popup „Pakiety Dealerskie” — bezterminowo; po zamknięciu wraca po 3 dniach.
export const DISMISS_TTL_MS = 3 * 24 * 60 * 60 * 1000;

export const shouldShowMotorPromo = (now, dismissedAtRaw) => {
  if (!dismissedAtRaw) {
    return true;
  }

  const dismissedAt = Number(dismissedAtRaw);

  if (!Number.isFinite(dismissedAt)) {
    return true;
  }

  return now.getTime() - dismissedAt > DISMISS_TTL_MS;
};
